/**
 * Info Cards Component
 * Displays informational cards for Enterprise Value info and valuation quiz
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Info, CheckCircle } from 'lucide-react';

const InfoCards = ({ onShowEVModal, onShowQuiz }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <button
        onClick={onShowEVModal}
        className="flex items-start gap-3 p-4 bg-blue-50 border border-blue-200 rounded-lg hover:bg-blue-100 transition-colors text-left"
      >
        <Info className="text-blue-600 mt-1" size={20} />
        <div>
          <h3 className="font-semibold text-blue-900">What is Enterprise Value (EV)?</h3>
          <p className="text-sm text-blue-700">Learn how we calculate your business value</p>
        </div>
      </button>

      <button
        onClick={onShowQuiz}
        className="flex items-start gap-3 p-4 bg-green-50 border border-green-200 rounded-lg hover:bg-green-100 transition-colors text-left"
      >
        <CheckCircle className="text-green-600 mt-1" size={20} />
        <div>
          <h3 className="font-semibold text-green-900">Not sure which method to use?</h3>
          <p className="text-sm text-green-700">Take our quick quiz to find the best method for you</p>
        </div>
      </button>
    </div>
  );
};

InfoCards.propTypes = {
  onShowEVModal: PropTypes.func.isRequired,
  onShowQuiz: PropTypes.func.isRequired
};

export default InfoCards;
